export default "__VITE_ASSET__05333359__"